<template>
<div>
  <div class="select">
    <el-tag
    closable
    disable-transitions="true"
    v-for="tag in backDatas"
    :key="tag.index"
    @close="handleCloseUser(tag)"
    >
    {{tag.name}}
    </el-tag>
    <el-button icon="el-icon-plus"  circle class="new-tag" size="small" @click="handleSelect" />
  </div>
  <component
  :is="typeComponent"
  isHeadimg
  :multiple="multiple"
  :visible.sync="dialogVisible"
  :backDatas="backDatas"
  @onChecked="handleChecked" />
</div>
</template>

<script>
import _ from 'lodash'
import UserSelect, { OrgSelect, RoleSelect } from '@/framework/components/user'
// <UserSelect :visible.sync="dialogVisible" @onChecked="handleCheckedUser" />
export default {
  props: {
    title: {
      type: String,
      default: '选择机构'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    datas: {
      type: Array,
      default: () => []
    },
    componentName: {
      type: String,
      default: 'UserSelect'
    }
  },
  components: {
    UserSelect,
    OrgSelect,
    RoleSelect
  },
  data() {
    return {
      backDatas: [],
      dialogVisible: false
    }
  },
  computed: {
    typeComponent() {
      return this.componentName
    }
  },
  watch: {
    // backDatas(users) {
    //   this.$emit('onChecked', users)
    // },
    datas(users) {
      this.backDatas = users
    }
  },
  mounted() {
    setTimeout(() => {
      this.backDatas = this.datas
    }, 100)
  },
  methods: {
    handleSelect() {
      this.dialogVisible = !this.dialogVisible
    },
    handleCloseUser(tag) {
      const tags = _.filter(this.backDatas, (user) => {
        return user.id !== tag.id
      })
      this.backDatas = tags
      this.$emit('onChecked', tags)
    },
    handleChecked(users) {
      this.backDatas = users
      this.$emit('onChecked', users)
    }
  }
}
</script>

<style lang='scss' scoped>
.select{
  border-radius:5px;
  border:1px solid #DCDFE6;
  padding: 4px 4px 0 4px;
  .el-tag, .new-tag {
    margin-left: 10px;
    margin-bottom: 5px;
  }
}
</style>
